<template>
  <v-navigation-drawer v-model="drawer" :mini-variant="mini" app dark>
    <v-list>
      <v-list-item>
        <v-list-item-avatar>
          <v-avatar color="white">
            <v-icon color="grey darken-4">mdi-dump-truck</v-icon>
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-title class="company-name white--text">{{ user.company_name }}</v-list-item-title>
      </v-list-item>
      <v-divider></v-divider>
      <v-list-item v-for="item in getItems" :key="item.text" @click.prevent="comform(item.link)" @mouseenter="mouseEnterMenuShow(item)" @mouseleave="mouseLeaveMenuHidden">
        <v-tooltip right color="grey darken-4" transition="scroll-x-transition" :disabled="!mini">
          <template v-slot:activator="{ on }">
            <v-list-item-icon v-on="on">
              <v-icon color="white">{{ item.icon }}</v-icon>
            </v-list-item-icon>
          </template>
          <span>{{hoverMenuString}}</span>
        </v-tooltip>
        <v-list-item-title class="menu-title white--text">{{ item.text }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "GlobalSidebar",
  props: ['user', 'drawer', 'mini'],
  data: () => ({
    items: [
      { name: "", icon: "mdi-view-dashboard-variant", text: "ダッシュボード", link: "/dashboard" },
      { name: "CTSG00010", icon: "mdi-calendar-edit", text: "工事情報", link: "/construction" },
      { name: "CTSG00012", icon: "mdi-file-edit", text: "作業日報", link: "/report/daily/worker" },
      { name: "CTSG00018", icon: "mdi-file-multiple", text: "作業日報一括修正", link: "/report/bulk/workerBulk" },
      { name: "CTSG00019", icon: "mdi-file-multiple-outline", text: "作業日報(経費)一括修正", link: "/report/bulk/workerExpenseBulk" },
      { name: "CTSG00013", icon: "mdi-file-document-box-check-outline", text: "工事日報", link: "/report/daily/construction" },
      { name: "CTSG00016", icon: "mdi-google-analytics", text: "分析情報", link: "/analysis" },
      { name: "CTSG00003", icon: "mdi-check-decagram", text: "権限情報", link: "/permissions" },
      { name: "CTSG00020", icon: "mdi-message-bulleted", text: "お知らせ情報", link: "/notification" },
      { name: "CTSG00017", icon: "mdi-playlist-edit", text: "工番情報", link: "/fix" },
      { name: "CTSG00005", icon: "mdi-office-building", text: "部署情報", link: "/department" },
      { name: "CTSG00015", icon: "mdi-cards", text: "等級情報", link: "/rank" },
      { name: "CTSG00004", icon: "mdi-account", text: "ユーザー情報", link: "/user" },
      { name: "CTSG00006", icon: "mdi-account-tie", text: "取引先情報", link: "/suppliers" },
      { name: "CTSG00009", icon: "mdi-expand-all", text: "集計費目情報", link: "/aggregate" },
      { name: "CTSG00007", icon: "mdi-focus-field-horizontal", text: "費目情報", link: "/expense" },
      { name: "CTSG00008", icon: "mdi-file-tree", text: "費目テンプレート情報", link: "/template" },
    ],
    // システム管理者用
    systemItems: [
      { name: "", icon: "mdi-view-dashboard-variant", text: "ダッシュボード", link: "/dashboard" },
      { name: "CTSG00021", icon: "mdi-comment-question", text: "問い合わせ一覧", link: "/inquiry" },
      { name: "CTSG00022", icon: "mdi-message-bulleted", text: "システムお知らせ情報", link: "/system_notification" },
    ],
    hoverMenuString: ""
  }),
  created() {
    this.initialize();
  },
  computed: {
    getItems() {
      var items = this.items;
      if (this.user.role_id === 2) {
        items = this.systemItems
      }
      return items
    }
  },
  methods: {
    initialize() {
      if (this.user.role_id === 2) {
        return
      }
      var itemIndex = 0;
      if (this.user.role_id === 0) {
        // 一般は権限、工番修正の操作不可
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00003');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00017');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00020');
        this.items.splice(itemIndex, 1);
      } else if (this.user.role_id === 1) {
        // 管理者は工事情報、作業日報、工事日報、分析情報、作業日報一括修正、作業日報(経費)一括修正の操作不可
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00010');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00012');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00013');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00016');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00018');
        this.items.splice(itemIndex, 1);
        itemIndex = this.items.findIndex(({name}) => name == 'CTSG00019');
        this.items.splice(itemIndex, 1);
      }
      for (var index in this.user.permission_config) {
        if (this.user.role_id === 0 && !this.user.permission_config[index].read) {
          itemIndex = this.items.findIndex(({name}) => name == index);
          if (itemIndex >= 0) {
            this.items.splice(itemIndex, 1);
          }
        }
      }
    },
    mouseEnterMenuShow (item) {
      this.hoverMenuString = item.text;
    },
    mouseLeaveMenuHidden () {
      this.hoverMenuString = "";
    },
    comform (value) {
      if (this.$route.path != value) {
        this.$emit('comform', value);
      }
    }
  }
};
</script>

<style scoped>
.v-application--is-ltr .v-list-item__avatar:first-child {
  margin-right: 0px;
}
.company-name {
  font-size: 18px !important;
  margin-left: 24px;
}
.menu-title {
  margin-left: 32px;
}
.v-application--is-ltr .v-list-item__icon:first-child {
  margin-right: 0px;
}
</style>
